module.exports = __webpack_public_path__ + "img/the_moon_chasers.9dbf0085.jpg";